<template>
  <v-sheet
    class="cursor-pointer overflow-hidden rounded-lg"
    width="100%"
    height="100%"
  >
    <v-sheet
      v-ripple
      class="rounded-lg overflow-hidden"
      width="100%"
      height="100%"
      @click="$emit('show')"
    >
      <ImageMedia
        class="w-100 h-100"
        height="100%"
        :key="image.id"
        :size="IMAGE_SIZES.CARD"
        :src="image"
      />
    </v-sheet>

    <Button
      v-if="!readOnly"
      fab
      class="delete-main-image-button"
      color="black"
      icon="mdi-close"
      size="x-small"
      @click="$emit('remove')"
    />
  </v-sheet>
</template>

<script>
import { IMAGE_SIZES } from 'rever-media-sdk'

import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'MediaContainerMainImage',

  components: {
    ImageMedia,
    Button,
  },

  props: {
    readOnly: Boolean,
    image: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      IMAGE_SIZES,
    }
  },
}
</script>

<style lang="scss" scoped>
.delete-main-image-button {
  position: absolute;
  top: -8px;
  right: -8px;
}
</style>
